import { Button } from 'components/deprecated/Button';
import { Uploader } from 'components/Uploader';
import { cx } from '@linaria/core';
import { useUploadAreaContext } from 'components/UploadArea/UploadAreaProvider/context';
import { flex } from 'styles/utils';
import { textAreaStyles, textInputContainerStyles, submitContainer } from './TextUploader.styles';

const textAreaPlaceholder = 'Type your own text here.';

export const TextUploader = (): JSX.Element => {
  const { onDrop, mediaType, dropzoneOptions, submitHandler, textValue, onTextChange } = useUploadAreaContext();

  return (
    <div data-testid="text-upload-area">
      <form onSubmit={submitHandler}>
        <div className={textInputContainerStyles}>
          <textarea
            className={textAreaStyles}
            onChange={onTextChange}
            placeholder={textAreaPlaceholder}
            value={textValue}
            data-testid="text-url-input"
            aria-label="text input"
          />
        </div>
        <div className={cx(flex.init, flex.justifyContent.end, submitContainer)}>
          <Button type="submit" data-testid="text-submit-button">
            Submit
          </Button>
        </div>
        <Uploader onDrop={onDrop} mediaType={mediaType} dropzoneOptions={dropzoneOptions} />
      </form>
    </div>
  );
};
